export default {
  name: "PageNotFound"
};